export const CONFIG = {
  IS_PRODUCTION: true,
  WHITELABEL_THEME_COLOR: "#1677ff",
  WHITELABEL_LOGO: "",
  DEFAULT_ANON_SHORTLINK_HOST:
    "https://officex.otterpad.cc/v1/drive/DriveID_njhmk-dpovk-olwku-6jau5-2ntzv-quxoz-xj5ni-w3pqm-wtzwu-ljdrn-dae/organization/shortlink",
  MIXPANEL_TOKEN: "cae2fd45d17ff2cdf642b1d8afd80aa8",
  SENTRY_DSN:
    "https://7318871d946d0b2499144d76db1f4d8a@o4509816418336768.ingest.us.sentry.io/4509816419713024",
};

// Storacha
// WHITELABEL_THEME_COLOR: "#E91215",
// WHITELABEL_LOGO:
//   "https://firebasestorage.googleapis.com/v0/b/arbitrage-bot-ea10c.appspot.com/o/officex%2Fwhitelabel%2FMask%20group%20(17).png?alt=media&token=0c663529-565d-4745-85a1-5da0b50262eb",

// Xenea
// WHITELABEL_THEME_COLOR: "#242424",
//   WHITELABEL_LOGO:
//     "https://firebasestorage.googleapis.com/v0/b/arbitrage-bot-ea10c.appspot.com/o/officex%2Fwhitelabel%2FMask%20group%20(11).png?alt=media&token=60c461ed-c417-47be-9a25-06fc55583a96",

// Walrus
// WHITELABEL_THEME_COLOR: "#0AC2AD",
//   WHITELABEL_LOGO:
//     "https://firebasestorage.googleapis.com/v0/b/arbitrage-bot-ea10c.appspot.com/o/officex%2Fwhitelabel%2FMask%20group%20(21).png?alt=media&token=09bca1a5-3ceb-46eb-88c1-f1ca6000b176",

// Dmail
// WHITELABEL_THEME_COLOR: "#3d3d3d",
//   WHITELABEL_LOGO:
//     "https://firebasestorage.googleapis.com/v0/b/arbitrage-bot-ea10c.appspot.com/o/officex%2Fwhitelabel%2FMask%20group%20(22).png?alt=media&token=9e453a21-d755-4b21-b672-f85b306ce42b",

// Rwanda
// WHITELABEL_THEME_COLOR: "#28ADE6",
//   WHITELABEL_LOGO:
//     "https://firebasestorage.googleapis.com/v0/b/arbitrage-bot-ea10c.appspot.com/o/officex%2Fwhitelabel%2FMask%20group%20(24).png?alt=media&token=0e1dd9d8-9ed9-48b1-ad79-248c242ba3e4",

// United Nations
// WHITELABEL_THEME_COLOR: "#009EDC",
//   WHITELABEL_LOGO:
//     "https://firebasestorage.googleapis.com/v0/b/arbitrage-bot-ea10c.appspot.com/o/officex%2Fwhitelabel%2FMask%20group%20(27).png?alt=media&token=3a942794-eaed-4eca-b656-fe07d2b10b67",

// University of Manila
// WHITELABEL_THEME_COLOR: "#24750B",
//   WHITELABEL_LOGO:
//     "https://firebasestorage.googleapis.com/v0/b/arbitrage-bot-ea10c.appspot.com/o/officex%2Fwhitelabel%2FMask%20group%20(29).png?alt=media&token=e3244392-944d-4752-a3a0-6fcb31106ebf",

// MistralAI
// WHITELABEL_THEME_COLOR: "#FF8204",
//   WHITELABEL_LOGO:
//     "https://firebasestorage.googleapis.com/v0/b/arbitrage-bot-ea10c.appspot.com/o/officex%2Fwhitelabel%2FMask%20group%20(31).png?alt=media&token=85c5704e-251f-4a6b-b0c6-e04630168e30",
